import { HelpOutline } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { ReactElement } from "react";

import { FlexBox } from "./FlexBox";

export default function SupportWidget(): ReactElement | null {
  return (
    <FlexBox gap="2">
      <Button
        href="https://support.scaletowin.com/knowledge-base"
        rel="noopener noreferrer"
        target="_blank"
        color="inherit"
        variant="link"
        aria-label="Open support knowledge base (opens in new tab)"
        sx={{
          p: 2,
          width: "100%",
          justifyContent: "flex-start",
          textTransform: "none",
          textDecoration: "none",
        }}
      >
        <HelpOutline sx={{ mr: "10px" }} />
        <Typography
          className="listItemText"
          display="inline"
          sx={{ mb: "2px" }}
        >
          Support
        </Typography>
      </Button>
    </FlexBox>
  );
}
